<template>
  <div id="vue-admin-index">
    <a-config-provider :locale="isEn ? enUS : zhCN">
      <!-- <a-locale-provide :locale="zh_CN"> -->
      <router-view />
      <!-- </a-locale-provide> -->
    </a-config-provider>
  </div>
</template>
<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN'
  import enUS from 'ant-design-vue/es/locale/en_US'
  import i18n from './locales'

  export default {
    name: 'App',
    computed: {
      isEn() {
        return i18n.global.locale == 'en-US'
      },
    },
    watch: {
      $route: {
        handler(route) {
          if (route.meta) {
            const model = route.meta.model
            if (model) {
              this.$store.commit('routes/setSider', model)
            } else {
              // console.log('Sider Model:', model, route)
            }
          }
        },
        immediate: true,
      },
    },
    data() {
      return {
        enUS,
        zhCN,
        // locale: this.isEn ? enUS : zhCN,
      }
    },
  }
</script>
<style lang="less">
  @import '~@/styles/index.less';
  td {
    word-break: break-word !important;
  }
  .full-modal {
    margin-top: 150px;
    .ant-modal-body {
      padding-top: 70px !important;
      padding-bottom: 40px;
    }
  }
</style>
